import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isSupabaseConfigured } from "../../shared/supabase/client";
import { SceneLoading } from "../../shared/ui/SceneLoading";
import { useSpaceStore } from "./model/spaceStore";

export function SpaceGate({ children }: PropsWithChildren) {
  const location = useLocation();
  const initialized = useSpaceStore((state) => state.initialized);
  const user = useSpaceStore((state) => state.user);
  const space = useSpaceStore((state) => state.space);
  if (!isSupabaseConfigured) return children;
  if (!initialized) return <SceneLoading />;
  if (!user) return <Navigate to={`/auth?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (!space) return <Navigate to="/space/setup" replace />;
  return children;
}

export function AuthGate({ children }: PropsWithChildren) {
  const location = useLocation();
  const initialized = useSpaceStore((state) => state.initialized);
  const user = useSpaceStore((state) => state.user);
  if (!isSupabaseConfigured) return children;
  if (!initialized) return <SceneLoading />;
  if (!user) return <Navigate to={`/auth?next=${encodeURIComponent(location.pathname)}`} replace />;
  return children;
}
